import { Component, OnInit, ChangeDetectorRef, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { UfService } from '../../core/services/uf.service';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ToastModule } from 'primeng/toast';
import { MainComponent } from '../main/main.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { FooterComponent } from '../footer/footer.component';
import { SidemenuComponent } from '../sidemenu/sidemenu.component';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerService } from '../../core/services/spinner.service';
import { ValoresReceberService } from '../../core/services/valoresareceber.service';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { RecebidosService } from '../../core/services/recebidos.service';
import { DataService } from '../../core/services/data.service';
import { PessoaService } from '../../core/services/pessoa.service';
import { PessoaDebitosService } from '../../core/services/pessoa.debitos.service';
import { PessoaCreditoService } from '../../core/services/pessoa.credito.service';
import { PessoaBoletoService } from '../../core/services/pessoa.boleto.service';
import { CsvExportService } from '../../core/services/excel.service';
import { LayoutService } from '../../shared/services/layout.service';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

import ptBr from '@angular/common/locales/pt';
import { debug } from 'console';
registerLocaleData(ptBr);

@Component({
    selector: 'app-container',
    standalone: true,
    imports: [
        CommonModule,
        HttpClientModule,
        ToastModule,
        MainComponent,
        ProgressSpinnerModule,
        NavbarComponent,
        FooterComponent,
        SidemenuComponent,
        ButtonModule
    ],
    templateUrl: './container.component.html',
    styleUrl: './container.component.scss',
    providers: [MessageService, UfService, RecebidosService,
        SpinnerService, PessoaDebitosService,
        PessoaBoletoService, PessoaCreditoService, DataService, CsvExportService,
        ValoresReceberService, PessoaService,
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' }
    ]
})
export class ContainerComponent implements OnInit {
    title = 'Painel Financeiro';
    pt: any;
    animar: boolean;
    visible: boolean = false;
    overlayMenuOpenSubscription: Subscription;
    menuOutsideClickListener: any;
    profileMenuOutsideClickListener: any;
    @ViewChild(SidemenuComponent) appSidebar!: SidemenuComponent;
    @ViewChild(NavbarComponent) appTopbar!: NavbarComponent;

    constructor(private primengConfig: PrimeNGConfig,
        private spinnerService: SpinnerService,
        private changeDetector: ChangeDetectorRef,
        public renderer: Renderer2,
        public router: Router,
        public layoutService: LayoutService) {


        this.overlayMenuOpenSubscription = this.layoutService.overlayOpen$.subscribe(() => {
            if (!this.menuOutsideClickListener) {
                this.menuOutsideClickListener = this.renderer.listen('document', 'click', event => {
                    const isOutsideClicked = !((this.appSidebar.el && this.appSidebar.el.nativeElement.isSameNode(event.target))
                        || (this.appSidebar.el && this.appSidebar.el.nativeElement.contains(event.target))
                        || (this.appTopbar.menuButton && this.appTopbar.menuButton.nativeElement.isSameNode(event.target))
                        || (this.appTopbar.menuButton && this.appTopbar.menuButton.nativeElement.contains(event.target)));

                    if (isOutsideClicked) {
                        this.hideMenu();
                    }
                });
            }

            if (!this.profileMenuOutsideClickListener) {
                this.profileMenuOutsideClickListener = this.renderer.listen('document', 'click', event => {
                    const isOutsideClicked = !((this.appTopbar.menu && this.appTopbar.menu.nativeElement.isSameNode(event.target))
                        || (this.appTopbar.menu && this.appTopbar.menu.nativeElement.contains(event.target))
                        || (this.appTopbar.topbarMenuButton && this.appTopbar.topbarMenuButton.nativeElement.isSameNode(event.target))
                        || (this.appTopbar.topbarMenuButton && this.appTopbar.topbarMenuButton.nativeElement.contains(event.target)));

                    if (isOutsideClicked) {
                        this.hideProfileMenu();
                    }
                });
            }

            if (this.layoutService.state.staticMenuMobileActive) {
                this.blockBodyScroll();
            }
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.hideMenu();
                this.hideProfileMenu();
            });
    }

    toggleMenu(): void {
        this.layoutService.toggleMenu();
    }

    async ngOnInit(): Promise<void> {
        this.primengConfig.ripple = true;
        this.spinnerService.animar$.subscribe(value => { this.animar = value });
        // Configurações de tradução do PrimeNG
        this.pt = {
            closeText: 'Fechar',
            prevText: 'Anterior',
            nextText: 'Próximo',
            currentText: 'Começo',
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            weekHeader: 'Semana',
            firstDay: 0,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Só Horas',
            timeText: 'Tempo',
            hourText: 'Hora',
            minuteText: 'Minuto',
            secondText: 'Segundo',
            ampm: false,
            month: 'Mês',
            week: 'Semana',
            day: 'Dia',
            allDayText: 'Todo o Dia',
            selectionMessage: 'Itens Selecionados'
        };

        this.primengConfig.setTranslation(this.pt);

        this.layoutService.menuVisible$.subscribe(visible => {
            this.visible = visible;
        });
    }

    ngAfterContentChecked(): void {
        this.changeDetector.detectChanges();
    }

    hideMenu() {
        this.layoutService.state.overlayMenuActive = false;
        this.layoutService.state.staticMenuMobileActive = false;
        this.layoutService.state.menuHoverActive = false;
        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
            this.menuOutsideClickListener = null;
        }
        this.unblockBodyScroll();
    }

    hideProfileMenu() {
        this.layoutService.state.profileSidebarVisible = false;
        if (this.profileMenuOutsideClickListener) {
            this.profileMenuOutsideClickListener();
            this.profileMenuOutsideClickListener = null;
        }
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        }
        else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        }
        else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    get containerClass() {
        return {
            'layout-theme-light': this.layoutService.config().colorScheme === 'light',
            'layout-theme-dark': this.layoutService.config().colorScheme === 'dark',
            'layout-overlay': this.layoutService.config().menuMode === 'overlay',
            'layout-static': this.layoutService.config().menuMode === 'static',
            'layout-static-inactive': this.layoutService.state.staticMenuDesktopInactive && this.layoutService.config().menuMode === 'static',
            'layout-overlay-active': this.layoutService.state.overlayMenuActive,
            'layout-mobile-active': this.layoutService.state.staticMenuMobileActive,
            'p-input-filled': this.layoutService.config().inputStyle === 'filled',
            'p-ripple-disabled': !this.layoutService.config().ripple
        }
    }

    ngOnDestroy(): void {
        if (this.overlayMenuOpenSubscription) {
            this.overlayMenuOpenSubscription.unsubscribe();
        }

        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
        }

        if (this.profileMenuOutsideClickListener) {
            this.profileMenuOutsideClickListener();
        }
    }
}
